import { createSlice } from '@reduxjs/toolkit';

const issues = createSlice({
  name: 'issues',
  initialState: {
    rut: '',
    orderId: '',
    sku: '',
    purchaseDate: '',
    commune: '',
    giftCardNumber: '',
    problemsGiftcard: '',
    motiveId: '',
    codeClubes: '',
    status: '',
    messages: '',
    description: '',
    cud: '',
    title: '',
    image: '',
    price: '',
  },
  reducers: {
    setRut(state, action) {
      state.rut = action.payload;
    },
    setOrderId(state, action) {
      state.orderId = action.payload;
    },
    setSku(state, action) {
      state.sku = action.payload;
    },
    setPurchaseDate(state, action) {
      state.purchaseDate = action.payload;
    },
    setCommune(state, action) {
      state.commune = action.payload;
    },
    setGiftCardNumber(state, action) {
      state.giftCardNumber = action.payload;
    },
    setProblemsGiftcard(state, action) {
      state.problemsGiftcard = action.payload;
    },
    setMotiveId(state, action) {
      state.motiveId = action.payload;
    },
    setCodeClubes(state, action) {
      state.codeClubes = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    setMessages(state, action) {
      state.messages = action.payload;
    },
    setDescription(state, action) {
      state.description = action.payload;
    },
    setCud(state, action) {
      state.cud = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
    setImageUrl(state, action) {
      state.image = action.payload;
    },
    setPrice(state, action) {
      state.price = action.payload;
    },
  },
});

export const {
  setRut,
  setOrderId,
  setSku,
  setPurchaseDate,
  setCommune,
  setGiftCardNumber,
  setProblemsGiftcard,
  setMotiveId,
  setCodeClubes,
  setStatus,
  setMessages,
  setDescription,
  setCud,
  setTitle,
  setImageUrl,
  setPrice,
} = issues.actions;
export default issues.reducer;
